import { NavigationGuard } from "vue-router";
import { $api, User } from "..";
import { InNavigateRespectively } from "./guards.util";

export enum OUT_NAV_NAMES {
  VERIFY = "verify",
  RESET = "reset",
}
export const OutGuardGenerate = () => {
  /**
   *
   * @param to
   * @param from
   * @param next
   */
  return function (to, from, next) {
    console.log(to, " Accessing the auth routes ");
    /**
     * If trying to verify account or
     * reset password
     */
    if ([OUT_NAV_NAMES.VERIFY, OUT_NAV_NAMES.RESET].includes(to.name as any)) {
      next();
      /**
       * If trying to do sometheing else
       */
    } else {
      $api.main
        .get<User>("/v1/account")
        .then((resp) => {
          InNavigateRespectively(resp.data, to, from, next);
        })
        .catch((err) => {
          // If internet leave it
          // document.replace(internetProblem)
          // If not stay on login
          next();
        });
    }
  } as NavigationGuard;
};
